import React from "react";
import PortalModal from "../../Portals";
import { IconButton } from "@material-ui/core";
import Tooltip from "@material-ui/core/Tooltip";
import { ReactComponent as CloseIcon } from "../../themes/Icons/close_icon.svg";
import {
  ContentModalActiveSurvey,
  CloseModalActiveSurvey,
  TextModalActiveSurvey,
  ButtonActiveSurvey,
  ButtonActiveSurveyCancel,
  ContentModal,
  ActionButtons,
} from "./ModalSaveToBank.styled";
import { SAVE_TO_BANK } from "../../GraphQL/Mutations";
import { NotificationManager } from "react-notifications";
import { useMutation } from "@apollo/client";

const ModalSaveToBank = ({
  idQuestion,
  category,
  categories,
  setModalVisibility,
}) => {
  const [saveQuestionToBank] = useMutation(SAVE_TO_BANK);

  const handleSaveToBank = () => {
    saveQuestionToBank({
      variables: {
        idQuestionSurvey: idQuestion,
      },
    })
      .then((response) => {
        if (response.data) {
          NotificationManager.success(
            "Question saved to bank successfully",
            "",
            5000
          );
        }
      })
      .catch((error) => {
        const errorMessage = error.message.split("\n")[0];
        NotificationManager.error(errorMessage, "", 5000);
      });
  };

  const getCategoryText = () => {
    let record = categories.filter((item) => {
      return item.idCategoryQuestion == category;
    });
    return record[0]?.description;
  };

  return (
    <PortalModal>
      <ContentModal>
        <ContentModalActiveSurvey>
          <CloseModalActiveSurvey>
            <Tooltip title="close">
              <IconButton>
                <CloseIcon onClick={() => setModalVisibility(false)} />
              </IconButton>
            </Tooltip>
          </CloseModalActiveSurvey>
          <TextModalActiveSurvey>
            <p>
              Are you sure you want to save this question into the{" "}
              {getCategoryText()} category?
            </p>
          </TextModalActiveSurvey>
          <ActionButtons>
            <ButtonActiveSurvey
              onClick={() => {
                handleSaveToBank();
                setModalVisibility(false);
              }}
            >
              OK
            </ButtonActiveSurvey>
            <ButtonActiveSurveyCancel onClick={() => setModalVisibility(false)}>
              Cancel
            </ButtonActiveSurveyCancel>
          </ActionButtons>
        </ContentModalActiveSurvey>
      </ContentModal>
    </PortalModal>
  );
};

export default ModalSaveToBank;
